import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "edit-relations-card"
};
const _hoisted_2 = {
  class: "preview-container"
};
const _hoisted_3 = {
  class: "preview-side"
};
const _hoisted_4 = {
  class: "preview-card"
};
const _hoisted_5 = {
  class: "preview-name"
};
const _hoisted_6 = {
  style: {
    "font-weight": "normal",
    "font-size": "0.75rem"
  }
};
const _hoisted_7 = {
  class: "preview-side"
};
const _hoisted_8 = {
  class: "preview-card"
};
const _hoisted_9 = {
  class: "preview-name"
};
const _hoisted_10 = {
  style: {
    "font-weight": "normal",
    "font-size": "0.75rem"
  }
};
const _hoisted_11 = {
  class: "relations-position-held"
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 1,
  class: "default-position-held"
};
const _hoisted_14 = {
  class: "relations-license"
};
const _hoisted_15 = {
  key: 0,
  class: "relations-license-tips"
};
const _hoisted_16 = {
  class: "edit-container"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "optional-role-name"
};
const _hoisted_19 = {
  style: {
    "font-weight": "normal",
    "font-size": "0.75rem"
  }
};
const _hoisted_20 = {
  class: "operator-container"
};
import { ref, computed, onMounted, watch } from 'vue';
import { ElButton, ElImage, ElInput, ElInputNumber, ElMessage, ElSelect, ElSwitch } from 'element-plus';
import store from '@/store';
import { request } from '@/manager/net_manager';
import _ from 'lodash';
export default {
  __name: 'WORWORelationsEditCard',
  props: {
    relation: {
      type: Object,
      required: true
    }
  },
  emits: ['edit-relations', 'create-relations', 'update-relations', 'remove-relations'],

  setup(__props, {
    emit: __emit
  }) {
    const degreeOptions = ['C', 'B', 'A', 'S', 'SS'];
    const props = __props;
    const emits = __emit; // refs

    const message = ref(null);
    const localRelation = ref(null);
    const searchRole = ref('');
    const optionalRoles = ref([]);
    const organization = ref(null); // computed

    const worldOutlook = computed(() => store.state.world_outlook || null);
    const organizations = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.organizations ?? null;
    }); // functions

    function findRole() {
      if (message.value) {
        message.value.close();
      }

      if (!searchRole.value || searchRole.value.length === 0) {
        message.value = ElMessage.error({
          message: '无检索信息',
          duration: 1500
        });
        return;
      }

      let parameters = {
        'world_outlook_id': worldOutlook.value.id,
        'search': searchRole.value,
        'numbers': 3
      };
      request('role/find_role/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        optionalRoles.value = response.data;
      });
    }

    const onOrganizationChanged = () => {
      const buffer = organizations.value.filter(item => item.id === organization.value);

      if (buffer.length !== 0) {
        localRelation.value.organization = buffer[0];
      }
    };

    const selectedRole = item => {
      localRelation.value.role = item;
    };

    const submitRelations = () => {
      if (!localRelation.value.id) {
        emits('create-relations', localRelation.value);
      } else {
        emits('update-relations', localRelation.value);
      }
    };

    const removeRelations = () => {
      emits('remove-relations', localRelation.value);
    }; // lifecycle


    onMounted(() => {
      localRelation.value = _.cloneDeep(props.relation);

      if (props.relation.organization && props.relation.organization.id) {
        localRelation.value.organization.id = parseInt(props.relation.organization.id);
      }
    }); // watcher

    watch(() => props.relation, newValue => {
      localRelation.value = _.cloneDeep(newValue);

      if (newValue.organization && newValue.organization.id) {
        localRelation.value.organization.id = parseInt(newValue.organization.id);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      return localRelation.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_unref(ElImage), {
        src: localRelation.value.role.avatar,
        fit: "cover",
        draggable: "false"
      }, null, 8, ["src"]), _createElementVNode("text", _hoisted_5, [_createElementVNode("span", _hoisted_6, " id: " + _toDisplayString(localRelation.value.role.id) + "   ", 1), _createTextVNode(" " + _toDisplayString(localRelation.value.role.nickname) + " ", 1), _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1))]), _createElementVNode("text", {
        class: _normalizeClass(['relations-core', localRelation.value.is_core ? 'is_true' : 'is_false'])
      }, _toDisplayString(localRelation.value.is_core ? '核心组织' : '关联组织'), 3), _createElementVNode("text", {
        class: _normalizeClass(['relations-active', localRelation.value.is_active ? 'is_true' : 'is_false'])
      }, _toDisplayString(localRelation.value.is_active ? '生效' : '失效'), 3)])]), _cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_unref(ElImage), {
        src: localRelation.value.organization.emblem,
        fit: "cover",
        draggable: "false"
      }, null, 8, ["src"]), _createElementVNode("text", _hoisted_9, [_createTextVNode(_toDisplayString(localRelation.value.organization.name) + " ", 1), _createElementVNode("span", _hoisted_10, "   id: " + _toDisplayString(localRelation.value.organization.id), 1)]), _createElementVNode("text", _hoisted_11, [localRelation.value.position_held && localRelation.value.position_held.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(localRelation.value.position_held), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_13, " 普通成员（默认） "))]), _createElementVNode("text", _hoisted_14, [_createTextVNode(" 许可等级：" + _toDisplayString(localRelation.value.skills_degree_license) + " ", 1), localRelation.value.skills_degree_license > 0 && localRelation.value.skills_degree_license <= degreeOptions.length ? (_openBlock(), _createElementBlock("span", _hoisted_15, " 对应" + _toDisplayString(degreeOptions[localRelation.value.skills_degree_license - 1]) + "级技能 ", 1)) : _createCommentVNode("", true)])])])]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_col, {
        span: 11,
        style: {
          "align-items": "flex-end"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_unref(ElInput), {
            modelValue: searchRole.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchRole.value = $event),
            maxlength: "16",
            clearable: "",
            "show-word-limit": "",
            placeholder: "搜索角色"
          }, null, 8, ["modelValue"]), _createVNode(_unref(ElButton), {
            class: "find-role",
            onClick: findRole
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" 查找用户 ", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          style: {
            "margin-top": "1.0rem"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionalRoles.value, item => {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["optional-roles-card", item.id === localRelation.value.role.id ? 'selected-roles-card' : '']),
              key: item.id,
              onClick: $event => selectedRole(item)
            }, [_createVNode(_unref(ElImage), {
              src: item.avatar,
              fit: "cover",
              draggable: "false"
            }, null, 8, ["src"]), _createElementVNode("text", _hoisted_18, [_createTextVNode(_toDisplayString(item.nickname) + " ", 1), _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", _hoisted_19, " id: " + _toDisplayString(item.id), 1)])], 10, _hoisted_17);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        offset: 2,
        span: 11,
        style: {
          "align-items": "flex-start"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_unref(ElSelect), {
            modelValue: localRelation.value.organization.id,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => localRelation.value.organization.id = $event),
            "show-arrow": false,
            placeholder: "选择世界观组织",
            "popper-class": "commonPopper",
            class: _normalizeClass(organization.value ? 'selected-selector' : ''),
            onChange: onOrganizationChanged
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: `${item.id} - ${item.name}`,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "class"])]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElInput), {
              modelValue: localRelation.value.position_held,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => localRelation.value.position_held = $event),
              maxlength: "16",
              clearable: "",
              "show-word-limit": "",
              placeholder: "身份"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_col, {
            offset: 2,
            span: 11
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
              modelValue: localRelation.value.skills_degree_license,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => localRelation.value.skills_degree_license = $event),
              min: 0,
              max: 5,
              placeholder: "许可等级"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_unref(ElSwitch), {
            modelValue: localRelation.value.is_core,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => localRelation.value.is_core = $event),
            "active-text": localRelation.value.is_core ? '核心组织' : '',
            "inactive-text": localRelation.value.is_core ? '' : '关联组织',
            "inline-prompt": ""
          }, null, 8, ["modelValue", "active-text", "inactive-text"]), _createVNode(_unref(ElSwitch), {
            modelValue: localRelation.value.is_active,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => localRelation.value.is_active = $event),
            "active-text": localRelation.value.is_active ? '生效' : '',
            "inactive-text": localRelation.value.is_active ? '' : '失效',
            "inline-prompt": ""
          }, null, 8, ["modelValue", "active-text", "inactive-text"])]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_20, [_withDirectives(_createVNode(_unref(ElButton), {
        class: "remove-relations",
        onClick: removeRelations
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" 删除关系 ", -1)]))]),
        _: 1
      }, 512), [[_vShow, localRelation.value.id !== -1]]), _createVNode(_unref(ElButton), {
        onClick: submitRelations
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(localRelation.value.id ? '提交更新' : '提交创建'), 1)]),
        _: 1
      })])])) : _createCommentVNode("", true);
    };
  }

};